module.exports = __webpack_public_path__ + "static/54-27f7e6d1cc1b35a53428fc7beabf1055.png";